import { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import PublicLayout from '../components/PublicLayout';
import LoadingIndicator from '../components/commun/LoadingIndicator';
import { Toaster } from '../components/commun/Toaster/Toaster';
import { routes } from '../routes/public';
import FlightCateringManagement from 'modules/privatePages/FlightCateringManagement';

const Dashboard = lazy(() => import('../modules/privatePages/Dashboard/Dashboard'));
const Login = lazy(() => import('../modules/publicPages/Login'));
const NotFound = lazy(() => import('../modules/publicPages/NotFound'));
const ResetPassword = lazy(() => import('../modules/publicPages/ResetPassword'));

function PublicNavigation() {
  const [isConnected, setIsConnected] = useState(localStorage.getItem('isConnected'));

  useEffect(() => {
    // Clear the local storage
    if (localStorage.getItem('firstLoad') === null) {
      localStorage.clear();
      localStorage.setItem('firstLoad', 'false');
    }

    const handleStorageChange = () => {
      setIsConnected(localStorage.getItem('isConnected'));
    };

    window.addEventListener('storage', handleStorageChange);

    // Cleanup function
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL}>
      <PublicLayout>
        <Suspense fallback={<LoadingIndicator />}>
          <Routes>
            <Route path="/" element={<Navigate to={routes.login.route} />} />
            <Route path={routes.login.route} element={<Login />} />
            {isConnected === 'true' && (
              <Route path={routes.dashboard.route} element={<Dashboard />} />
            )}
            <Route path={routes.flightCateringManagement.route} element={<FlightCateringManagement />} />
            <Route path="*" element={<NotFound />} />
            <Route path={routes.resetPassword.route} element={<ResetPassword />} />
          
          </Routes>
        </Suspense>
        <Toaster />
      </PublicLayout>
    </BrowserRouter>
  );
}


export default PublicNavigation;
